import { useState } from "react";
import { api } from "../api";
import { useLoad } from "../hooks";
import { CommandBar } from "../Shell";
import { ErrorBox, label } from "../ui";

const BY = ["category", "work_center", "vendor", "item", "lot", "machine_center", "severity"];
const DAYS = [7, 30, 90, 365];

export function ParetoPage() {
  const [by, setBy] = useState("category");
  const [days, setDays] = useState(30);
  const { data, error } = useLoad(() => api.pareto(by, days), [by, days]);
  const max = data?.rows[0]?.count ?? 1;
  const fmt = (k: string) => (by === "category" || by === "severity" ? label(k) : k);

  return (
    <>
      <CommandBar status={data ? `${data.total} issue${data.total === 1 ? "" : "s"} · last ${days} days` : "Loading…"}>
        <label className="sr-only" htmlFor="days">Period</label>
        <select id="days" className="select" style={{ width: 150, height: 30 }} value={days} onChange={(e) => setDays(Number(e.target.value))}>
          {DAYS.map((d) => <option key={d} value={d}>Last {d} days</option>)}
        </select>
      </CommandBar>
      <div className="page">
        <div className="page-title"><h1>Pareto</h1><span className="sub">What's driving issues. The top bars are where a CAPA or kaizen pays off.</span></div>
        <div className="pivot" role="tablist">
          {BY.map((b) => <button key={b} role="tab" aria-selected={by === b} onClick={() => setBy(b)}>{label(b)}</button>)}
        </div>
        <ErrorBox error={error} />
        <section className="card">
          <div className="card-body">
            {!data ? <span className="muted">Loading…</span> : data.rows.length === 0 ? <span className="muted">No issues linked to a {label(by).toLowerCase()} in this period.</span> : (
              <div className="bars">
                {data.rows.map((r) => (
                  <div className="bar-row" key={r.key} style={{ gridTemplateColumns: "180px minmax(0, 1fr) 110px" }}>
                    <span className="k" title={r.key}>{fmt(r.key)}</span>
                    <span className="track" style={{ height: 22 }}><span className="fill" style={{ width: `${(r.count / max) * 100}%` }} /></span>
                    <span className="n"><b>{r.count}</b><small>{r.cumulativePct}% cum.</small></span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
}
